var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.topbar},[_vm._m(0),_c('div',{staticClass:"mr-4 d-none d-sm-block"},[_c('client-selector')],1),_c('div',{staticClass:"mr-4"},[_c('cui-user-menu')],1),_c('div',[_c('cui-theme-switch')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-50 cui__utils__heading mb-0 mr-auto"},[_c('strong',[_vm._v("Reporting Dashboard")])])
}]

export { render, staticRenderFns }